









































import { EGameSearchBy } from '@/api/schema';
import VMenuFilter from '@/components/VMenuFilter.vue';
import { mapState, mapActions, mapGetters } from 'vuex';

interface IFilterData {
  search: string;
  searchBy: EGameSearchBy;
  providers: string[];
}
interface ISelectItem {
  text: string;
  value: EGameSearchBy;
}
export default {
  name: 'CopyStakeWhitelistFilter',

  components: {
    VMenuFilter
  },

  props: {
    search: {
      type: String,
      default: ''
    },
    searchBy: {
      type: String,
      default: ''
    },
    isModal: {
      type: Boolean,
      default: false
    },
    providers: {
      type: Array,
      default: (): string[] => []
    }
  },

  data(): any {
    return {
      localSearch: this.search,
      localSearchBy: this.searchBy,
      localProviders: this.providers
    };
  },
  computed: {
    ...mapState('Providers', ['providersNames']),
    ...mapState('Onboarding', ['copyStakeIntegration']),
    ...mapGetters('Onboarding', ['operatorId']),
    searchByOptions(): ISelectItem[] {
      return [
        {
          text: 'Game Name',
          value: EGameSearchBy.NAME
        },
        {
          text: 'Game Code',
          value: EGameSearchBy.CODE
        }
      ];
    },

    currentSearchBy(): ISelectItem {
      return this.searchByOptions.find(
        (el: ISelectItem) => el.value === this.localSearchBy
      );
    },

    searchPlaceholder(): string {
      return `Search by ${this.currentSearchBy.text}`;
    },

    isUndegroundCasinoActive(): boolean {
      return this.copyStakeIntegration.crossOperatorCopyingAllowed;
    },

    providerOptions(): string[] {
      return this.providersNames.map((item) => ({ text: item, value: item }));
    }
  },
  watch: {
    operatorId: {
      handler(id: number): void {
        if (id) {
          this.getProviders();
        }
      },
      immediate: true
    },

    search(newVal: string): void {
      this.localSearch = newVal;
    },
    searchBy(newVal: string): void {
      this.localSearchBy = newVal;
    },
    providers(newVal: string[]): void {
      this.localProviders = newVal;
    },

    localProviders(): void {
      this.$emit('update-filter', this.formatDataFilter(this.localSearch));
    }
  },
  methods: {
    ...mapActions('Providers', ['getProviders']),
    formatDataFilter(search: string = null): IFilterData {
      const providers = this.localProviders.map((provider) => provider.value);
      return {
        search: search,
        searchBy: this.localSearchBy,
        providers
      };
    },

    handleClickSearchButton(): void {
      this.$emit('update-filter', this.formatDataFilter(this.localSearch));
    },

    handleClickSearchClearButton(): void {
      this.$emit('update-filter', this.formatDataFilter());
    },
    handleClickSyncButton(): void {
      this.$emit('sync');
    }
  }
};
